/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProxySummary,
    ProxySummaryFromJSON,
    ProxySummaryFromJSONTyped,
    ProxySummaryToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProxySummaryResponse
 */
export interface ProxySummaryResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof ProxySummaryResponse
     */
    msg: string;
    /**
     * 
     * @type {ProxySummary}
     * @memberof ProxySummaryResponse
     */
    entry: ProxySummary;
}

export function ProxySummaryResponseFromJSON(json: any): ProxySummaryResponse {
    return ProxySummaryResponseFromJSONTyped(json, false);
}

export function ProxySummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxySummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': ProxySummaryFromJSON(json['entry']),
    };
}

export function ProxySummaryResponseToJSON(value?: ProxySummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': ProxySummaryToJSON(value.entry),
    };
}


